import { render, staticRenderFns } from "./joinAuth.vue?vue&type=template&id=5d7e2257&scoped=true"
import script from "./joinAuth.vue?vue&type=script&lang=js"
export * from "./joinAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7e2257",
  null
  
)

export default component.exports